import { ItRequisitionTypeCodes } from '@Enum/api/ItRequisitionTypeCodes.enum';

export const itRequisitionTypeOptionsAllowed: Record<number, boolean> = {
  [ItRequisitionTypeCodes.NEW_SIM_CARD]: true,
  [ItRequisitionTypeCodes.EMAIL]: true,
  [ItRequisitionTypeCodes.BUILD_SMART_ACCESS]: true,
  [ItRequisitionTypeCodes.ACCESSORIES]: true,
  [ItRequisitionTypeCodes.INTERNATIONAL_CALLS]: true,
  [ItRequisitionTypeCodes.LOST_SIM_CARD]: true,
  [ItRequisitionTypeCodes.ASSET_STATUS_CHANGE]: true,
  [ItRequisitionTypeCodes.SIM_ADDON_REQUEST]: true,
};
